import React from "react"
import Layout from "../components/layout/layout"
import SEO from "../components/layout/seo"
import styled from "styled-components"
import BeTheProficient from "../components/Sections/BeTheProficient"
import ProductSection from "../components/Sections/Products"
import WelcomeSection from "../components/Sections/Welcome"

function IndexPage() {
  return (
    <Layout>
      <SEO title="Home" />
      <Sections>
        <WelcomeSection />
        <BeTheProficient />
        <ProductSection />
      </Sections>
    </Layout>
  )
}

export default IndexPage

const Sections = styled.div``
